import { Button, LinkButton } from '@/components/elements/forms/buttons';
import Icon from '@/components/icons/Icon';
import { DEFAULT_SEARCH_KEYWORD, DEFAULT_SEARCH_LOCATION } from '@/hooks/search/useSearch.constants';
import useMobileView from '@/hooks/useMobileView';
import { _s } from '@/locale';

const baseTranslationKey = 'features.searchV2.modules.NoSearchHits';

type NoSearchHitsProps = {
  isSistaminutenSearch: boolean;
  keyword: string;
  location: string;
  onExtendSearchClick: () => void;
  fetchingExtendedPlaces: boolean;
};

const NoSearchHits = ({
  isSistaminutenSearch,
  keyword,
  location,
  onExtendSearchClick,
  fetchingExtendedPlaces,
}: NoSearchHitsProps) => {
  const { isMobileView } = useMobileView();

  let search: string = undefined;

  if (keyword && location) {
    search = `${keyword} ${location}`;
  } else if (keyword) {
    search = keyword;
  } else if (location) {
    search = location;
  }

  const title = isSistaminutenSearch
    ? _s(`${baseTranslationKey}.titleSistaminuten`)
    : _s(`${baseTranslationKey}.title`);
  const description = isSistaminutenSearch
    ? _s(`${baseTranslationKey}.descriptionSistaminuten`, { search })
    : _s(`${baseTranslationKey}.description`, { search });
  const cta = isSistaminutenSearch ? _s(`${baseTranslationKey}.ctaSistaminuten`) : _s(`${baseTranslationKey}.cta`);

  const icon = isSistaminutenSearch ? 'smt' : 'search-no-result';

  if (isMobileView) {
    return (
      <div className="bg-surface_l3 p-xl rounded-md">
        <div className="gap-x-md mb-xs flex items-center justify-between">
          <span className="text-h-s text-fg_primary">{title}</span>
          <Icon variant={icon} size="md" />
        </div>
        <span className="text-fg_secondary text-m mb-lg inline-block">{description}</span>

        {isSistaminutenSearch && (
          <LinkButton
            variant="primary"
            to={`/${keyword || DEFAULT_SEARCH_KEYWORD}/${location || DEFAULT_SEARCH_LOCATION}`}>
            {cta}
          </LinkButton>
        )}
        {!isSistaminutenSearch && (
          <Button variant="primary" onClick={onExtendSearchClick} disabled={fetchingExtendedPlaces}>
            {cta}
          </Button>
        )}
      </div>
    );
  }

  return (
    <div className="bg-surface_l3 p-xl gap-x-md flex items-start rounded-md">
      <Icon variant={icon} size="md" />
      <div className="gap-x-md mb-xs flex flex-col">
        <span className="text-h-s text-fg_primary">{title}</span>
        <span className="text-fg_secondary text-m inline-block">{description}</span>
      </div>

      {isSistaminutenSearch && (
        <LinkButton
          variant="primary"
          to={`/${keyword || DEFAULT_SEARCH_KEYWORD}/${location || DEFAULT_SEARCH_LOCATION}`}
          className="shrink-0">
          {cta}
        </LinkButton>
      )}
      {!isSistaminutenSearch && (
        <Button variant="primary" onClick={onExtendSearchClick} className="shrink-0" disabled={fetchingExtendedPlaces}>
          {cta}
        </Button>
      )}
    </div>
  );
};

export default NoSearchHits;
